import { ApiaryScheme } from "widgets/apiaryScheme"

export const ApiarySchemePage = () => {
  return (
    <ApiaryScheme />
  )
}